import React, { useState } from 'react';
import { Divider } from '@material-ui/core';
import { IonIcon } from '@ionic/react';
import lotus_logo from '../../assets/images/common/lotus.svg';
import diamond_logo from '../../assets/images/common/diamond.svg';
import themechange from '../../assets/images/common/themechange.svg';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './Header.scss';
import { getSkinUrl } from '../../util/urlUtils';
const ThemeChanges = () => {
  const [showNewPotal, setShowNewPotal] = useState<boolean>(false);

  return (
    <>
      {showNewPotal ? (
        <div
          className="theme-opetion"
          onClick={() => setShowNewPotal(false)}
        >
          <div className="drop-down-list">
            <div
              className="ion-list-item"
              onClick={() => setShowNewPotal(false)}
              >
              {' '}
              <ArrowForwardIosIcon className="arrow" />
              <div className="text">Change Site</div>
            </div>
            <div
              className="ion-list-item"
              onClick={() =>
                window.open(
                  `https://${getSkinUrl('diamond')}/?authToken=${sessionStorage.getItem(
                    'jwt_token'
                  )}`,
                  '_self'
                )
              }
            >
              {' '}
              <IonIcon src={diamond_logo} className="sport-icon" />
              <div className="text">Diamond</div>
            </div>
            <Divider />
            <div
              className="ion-list-item"
              onClick={() =>
                window.open(
                  `http://${getSkinUrl('lotus')}/?authToken=${sessionStorage.getItem(
                    'jwt_token'
                  )}`,
                  '_self'
                )
              }
            >
              {' '}
              <IonIcon src={lotus_logo} className="sport-icon" />
              <div className="text">Lotus</div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="theme-opetion"
          onClick={() => setShowNewPotal(true)}
        >
          {' '}
          <div className="theme-menu">
            <IonIcon src={themechange} className="icon" />
          </div>
        </div>
      )}
    </>
  );
};

export default ThemeChanges;
